<div class="modal-close" (click)="closeModal()">
  <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon
  ><span>{{ "btn:close" | translate }}</span>
</div>
<div class="modal-header justify-content-start">
  <h4 class="modal-title fw-bold">
    {{ title }}
  </h4>
</div>
<div class="modal-body flex-column">
  <div class="row">
    <div style="margin-bottom: 0px!important;" class="mb-0 text p-margin" [innerHTML]="description"></div>
  </div>
</div>
<div class="row justify-content-end modal-footer">
  <div class="col-auto">
    <button
      type="button"
      role="tab"
      class="btn btn-primary btn-create ms-2 fs-15 text-nowrap"
      (click)="closeModal()"
    >
      <fa-icon
        class="mr-2"
        [icon]="faCircleNorch"
        *ngIf="loadSpin"
        [spin]="true"
      ></fa-icon>
      {{ "Start Movielearning" | translate }}
    </button>
  </div>
</div>
